import React from 'react';
import { formatPrice } from '@/lib/format';

// This artwork is the approved festive voucher, with its example amount and
// example code removed. The actual values remain live text, never part of the picture.
const ARTWORK = 'https://media.base44.com/images/public/6aa2c2af54cfb5bf4d045125/b47db631e_vintage_treyjur_gjafabref_dynamic_template.png';

export default function GiftCardVisual({ amount, code }) {
  const validAmount = Number.isFinite(Number(amount)) && Number(amount) > 0;
  return (
    <div className="relative w-full max-w-2xl mx-auto overflow-hidden" style={{ aspectRatio: '3 / 2' }}>
      <img
        src={ARTWORK}
        alt="Jólalegt rafrænt gjafabréf frá Vintage Treyjum, með vínrauðum grenigreinum og skrautramma"
        className="absolute inset-0 w-full h-full object-fill"
      />
      <svg viewBox="0 0 1536 1024" preserveAspectRatio="xMidYMid meet"
        className="absolute inset-0 w-full h-full pointer-events-none"
        aria-hidden="true">
        <text x="770" y="642" textAnchor="middle" fill="#65051f"
          fontFamily="Georgia, 'Times New Roman', serif" fontSize="88" fontWeight="bold">
          {validAmount ? formatPrice(Number(amount)).toUpperCase() : '— KR.'}
        </text>
        <rect x="787" y="711" width="434" height="67" rx="15" fill="#fff8f0" stroke="#65051f" strokeWidth="3" />
        <text x="1000" y="760" textAnchor="middle" fill="#65051f"
          fontFamily="Georgia, 'Times New Roman', serif" fontSize={String(code || '').length > 10 ? 41 : 49} fontWeight="bold">
          {code || 'XXXXXXXXXX'}
        </text>
      </svg>
      <span className="sr-only">Upphæð: {validAmount ? formatPrice(Number(amount)) : 'Ekki valin'}. Gjafabréfsnúmer: {code || 'birtist eftir greiðslu'}.</span>
    </div>
  );
}
